import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Context
import { AuthProvider } from '../../contexts/AuthContext';

// Layouts
import Header from '../Layouts/Header';
import PageContent from '../Layouts/PageContent';
import Footer from '../Layouts/Footer';

// Pages
import MarketingHomePage from '../Pages/Pages/MarketingHomePage';
import SigninPage from '../Pages/Pages/SigninPage';
import UserProfilePage from '../Pages/Pages/UserProfilePage';
import UserEditPage from '../Pages/Pages/UserEditPage';
import AccountProfilePage from '../Pages/Pages/AccountProfilePage';
import AccountEditPage from '../Pages/Pages/AccountEditPage';
import DashboardPage from '../Pages/Pages/DashboardPage';
import ShoppingCartPage from '../Pages/Pages/ShoppingCartPage';
import PropertyCreatePage from '../Pages/Pages/PropertyCreatePage';
import PropertyProfilePage from '../Pages/Pages/PropertyProfilePage';
import PropertyEditPage from '../Pages/Pages/PropertyEditPage';
import PropertyPOAPage from '../Pages/Pages/PropertyPOAPage';
import PropertyOwnershipPage from '../Pages/Pages/PropertyOwnershipPage';
import PropertyLicenseSurveyPage from '../Pages/Pages/PropertyLicenseSurveyPage';
import PropertyBusinessLicenseApplicationPage from './Pages/PropertyBusinessLicenseApplicationPage';
import RevenueReportingPage from '../Pages/Pages/RevenueReportingPage';
import HelpCenterHomePage from './Pages/HelpCenterHomePage';
import HelpCenterSearchPage from './Pages/HelpCenterSearchPage';
import ArticlePage from './Pages/ArticlePage';
import ReportAnIssuePage from './Pages/ReportAnIssuePage';
import BlogHomePage from './Pages/BlogHomePage';
import CombatingHomelessnessPage from './Pages/CombatingHomelessnessPage';
import ReleasesPage from './Pages/ReleasesPage';
import AboutUsPage from './Pages/AboutUsPage';
import RoadmapPage from './Pages/RoadmapPage';

export default function App(props) {
	const [
		store
	] = useState(props);
	// console.log('Store', store);

	return (
		<Router>
			<AuthProvider endpoints={store.endpoints}>
				<Header />
				<Routes>
					<Route
						path="/"
						element={
							<MarketingHomePage
								create_inquiry_endpoint={
									store.endpoints.create_inquiry_endpoint
								}
							/>
						}
					/>
				</Routes>
				<PageContent>
					<Routes>
						<Route
							path="/signin"
							element={
								<SigninPage
									sign_in_endpoint={store.endpoints.sign_in_endpoint}
								/>
							}
						/>
						<Route
							path="/dashboard"
							element={
								<DashboardPage
									get_accounts_by_user_endpoint={
										store.endpoints.get_accounts_by_user_endpoint
									}
									get_properties_by_account_endpoint={
										store.endpoints.get_properties_by_account_endpoint
									}
									get_files_by_property_endpoint={
										store.endpoints.get_files_by_property_endpoint
									}
								/>
							}
						/>
						<Route
							path="/cart"
							element={
								<ShoppingCartPage
									create_user_endpoint={store.endpoints.create_user_endpoint}
									create_account_endpoint={
										store.endpoints.create_account_endpoint
									}
									create_property_endpoint={
										store.endpoints.create_property_endpoint
									}
									create_property_ownership_endpoint={
										store.endpoints.create_property_ownership_endpoint
									}
									create_power_of_attorney_endpoint={
										store.endpoints.create_power_of_attorney_endpoint
									}
									create_business_license_survey_endpoint={
										store.endpoints.create_business_license_survey_endpoint
									}
									create_subscription_endpoint={
										store.endpoints.create_subscription_endpoint
									}
									create_payment_account_endpoint={
										store.endpoints.create_payment_account_endpoint
									}
								/>
							}
						/>
						<Route
							path="/users/1"
							element={
								<UserProfilePage
									get_user_endpoint={store.endpoints.get_user_endpoint}
								/>
							}
						/>
						<Route
							path="/users/1/edit"
							element={
								<UserEditPage
									get_user_endpoint={store.endpoints.get_user_endpoint}
									update_user_endpoint={store.endpoints.update_user_endpoint}
								/>
							}
						/>
						<Route
							path="/accounts/1"
							element={
								<AccountProfilePage
									get_account_endpoint={store.endpoints.get_account_endpoint}
								/>
							}
						/>
						<Route
							path="/accounts/1/edit"
							element={
								<AccountEditPage
									get_account_endpoint={store.endpoints.get_account_endpoint}
									update_account_endpoint={
										store.endpoints.update_account_endpoint
									}
								/>
							}
						/>
						<Route
							path="/properties/new"
							element={
								<PropertyCreatePage
									create_property_endpoint={
										store.endpoints.create_property_endpoint
									}
									create_property_ownership_endpoint={
										store.endpoints.create_property_ownership_endpoint
									}
									create_power_of_attorney_endpoint={
										store.endpoints.create_power_of_attorney_endpoint
									}
									create_business_license_survey_endpoint={
										store.endpoints.create_business_license_survey_endpoint
									}
									create_subscription_endpoint={
										store.endpoints.create_subscription_endpoint
									}
								/>
							}
						/>
						<Route
							path="/properties/:id"
							element={
								<PropertyProfilePage
									get_property_endpoint={store.endpoints.get_property_endpoint}
									get_property_ownership_by_property_endpoint={
										store.endpoints.get_property_ownership_by_property_endpoint
									}
								/>
							}
						/>
						<Route
							path="/properties/:id/details"
							element={
								<PropertyEditPage
									get_property_endpoint={store.endpoints.get_property_endpoint}
									update_property_endpoint={
										store.endpoints.update_property_endpoint
									}
								/>
							}
						/>
						<Route
							path="/properties/:id/poa"
							element={
								<PropertyPOAPage
									create_power_of_attorney_endpoint={
										store.endpoints.create_power_of_attorney_endpoint
									}
									update_power_of_attorney_endpoint={
										store.endpoints.update_power_of_attorney_endpoint
									}
								/>
							}
						/>
						<Route
							path="/properties/:id/ownership"
							element={
								<PropertyOwnershipPage
									create_property_ownership_endpoint={
										store.endpoints.create_property_ownership_endpoint
									}
									get_property_ownership_by_property_endpoint={
										store.endpoints.get_property_ownership_by_property_endpoint
									}
									update_property_ownership_endpoint={
										store.endpoints.update_property_ownership_endpoint
									}
								/>
							}
						/>
						<Route
							path="/properties/:id/license-survey"
							element={
								<PropertyLicenseSurveyPage
									create_business_license_survey_endpoint={
										store.endpoints.create_business_license_survey_endpoint
									}
									get_business_license_survey_by_property_endpoint={
										store.endpoints
											.get_business_license_survey_by_property_endpoint
									}
									update_business_license_survey_endpoint={
										store.endpoints.update_business_license_survey_endpoint
									}
									create_business_license_application_endpoint={
										store.endpoints.create_business_license_application_endpoint
									}
								/>
							}
						/>
						<Route
							path="/properties/:id/business-license-application"
							element={
								<PropertyBusinessLicenseApplicationPage
									create_business_license_application_endpoint={
										store.endpoints.create_business_license_application_endpoint
									}
									update_business_license_application_endpoint={
										store.endpoints.update_business_license_application_endpoint
									}
								/>
							}
						/>
						<Route
							path="/revenue/report"
							element={
								<RevenueReportingPage
									get_properties_endpoint={
										store.endpoints.get_properties_endpoint
									}
								/>
							}
						/>
						<Route
							path="/help"
							element={
								<HelpCenterHomePage
									get_articles_endpoint={store.endpoints.get_articles_endpoint}
								/>
							}
						/>
						<Route path="/help/search" element={<HelpCenterSearchPage />} />
						<Route path="/blog" element={<BlogHomePage />} />
						<Route
							path="/articles/:id"
							element={
								<ArticlePage
									get_article_endpoint={store.endpoints.get_article_endpoint}
								/>
							}
						/>
						<Route
							path="/issues"
							element={
								<ReportAnIssuePage
									create_issue_endpoint={store.endpoints.create_issue_endpoint}
								/>
							}
						/>
						<Route
							path="/community/combating-homelessness"
							element={<CombatingHomelessnessPage />}
						/>
						<Route path="/releases" element={<ReleasesPage />} />
						<Route path="/about-us" element={<AboutUsPage />} />
						<Route path="/roadmap" element={<RoadmapPage />} />
					</Routes>
				</PageContent>
				<Footer />
			</AuthProvider>
		</Router>
	);
}
